export class featureFlags {
  features: feature[] = [];
  userGroups: userGroups[] = [];
  countryGroups: countryGroups[] = [];

  static clone(fFlags: featureFlags) {
    const copy: featureFlags = new featureFlags();
    const feats = fFlags.features?.map(f => feature.clone(f)).filter(c => !!c) as feature[];
    if(feats?.length) copy.features = feats;
    const ctryGrp = fFlags.countryGroups?.map(c => countryGroups.clone(c)).filter(c => !!c) as countryGroups[];
    if(ctryGrp?.length) copy.countryGroups = ctryGrp;
    const uGrp = fFlags.userGroups?.map(u => userGroups.clone(u)).filter(c => !!c) as userGroups[];
    if(uGrp?.length) copy.userGroups = uGrp;
    return copy;
  }
}

export class feature {
  name: string;
  // true means feature conditions has to be checked to enable the feature
  // false means feature is always ON
  enabled = false;
  // multiple conditions serve as OR. If one condition object is true, feature is ON
  // while properties inside a condition serves as AND. If one property is false, condition is false.
  conditions: conditions[] = [];
  isUpdated?: boolean;

  static clone(feat: feature) {
    if(!feat.name) return undefined;
    const copy: feature = new feature();
    copy.name = feat.name;
    copy.enabled = feat.enabled;
    const conds = feat.conditions?.map(c => conditions.clone(c)).filter(c => !!c) as conditions[];
    if(conds?.length) copy.conditions = conds;
    else return undefined;
    return copy;
  }
}

export class conditions {
  countries: string[] = [];
  excludedCountries: string[] = [];
  userGroups: string[] = [];
  countryGroups: string[] = [];
  users: string[] = [];
  consoleTypes: string[] = [];
  facilityIds: string[] = [];
  isUpdated?: boolean;

  static ensure(copy: conditions) {
    copy.consoleTypes = copy.consoleTypes??[];
    copy.facilityIds = copy.facilityIds??[];
    copy.countries = copy.countries??[];
    copy.excludedCountries = copy.excludedCountries??[];
    copy.userGroups = copy.userGroups??[];
    copy.countryGroups = copy.countryGroups??[];
    copy.users = copy.users??[];
  }

  static clone(cond: conditions) {
    const copy: conditions = new conditions();
    const excludedCountries = cond.excludedCountries.filter(c => !!c);
    if(excludedCountries?.length) copy.excludedCountries = excludedCountries;
    const cnty = cond.countries.filter(c => !!c);
    if(cnty?.length) copy.countries = cnty;
    const ugrp = cond.userGroups.filter(c => !!c);
    if(ugrp?.length) copy.userGroups = ugrp;
    const cgrp = cond.countryGroups.filter(c => !!c);
    if(cgrp?.length) copy.countryGroups = cgrp;
    const usr = cond.users.filter(c => !!c);   
    if(usr?.length) copy.users = usr; 
    const cnsl = cond.consoleTypes.filter(c => !!c);  
    if(cnsl?.length) copy.consoleTypes = cnsl;
    const facs = cond.facilityIds.filter(c => !!c);  
    if(facs?.length) copy.facilityIds = facs; 

    if(!copy.countries?.length && !copy.userGroups?.length &&
      !copy.countryGroups?.length && !copy.users?.length &&
      !copy.consoleTypes?.length && !copy.facilityIds?.length  && !copy.excludedCountries?.length) return undefined;
    return copy;
  }
}

export class userGroups {
  name: string;
  users: string[] = [];
  isUpdated?: boolean;

  static clone(uGrp: userGroups) {
    if(!uGrp.name) return undefined;
    const copy: userGroups = new userGroups();
    copy.name = uGrp.name;
    copy.users = uGrp.users.filter(u => !!u);
    if(!copy.users?.length) return undefined;
    return copy;
  }
}

export class countryGroups {
  name: string;
  countries: string[] = [];
  isUpdated?: boolean;

  static clone(cGrp: countryGroups) {
    if(!cGrp.name) return undefined;
    const copy: countryGroups = new countryGroups();
    copy.name = cGrp.name;
    copy.countries = cGrp.countries.filter(c => !!c);
    if(!copy.countries?.length) return undefined;
    return copy;
  }
}